import { GB } from "@/modules/l10n/units.tsx";

export function Gb({ bytes }: { bytes: number }) {
    return (
        <>
            {(bytes / 1024 ** 3).toFixed(2)} {GB}
        </>
    );
}
